import camelcaseKeys from 'camelcase-keys'

export interface StationWorkoutResults {
  id: number
  completedExerciseCount: number
  startedAt: string,
  pixformanceScore: number
  precisionScore: number
  rangeScore: number
  tempoScore: number
  intensityRating: number
}

export class Feedback {
  key: string
  maxImpactFactor: number
  exercises: any[]

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

export class RepetitionResult {
  duration: number | null
  precisionScore: number | null
  rangeScore: number | null
  tempoScore: number | null

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

export class ExerciseResult {
  exerciseId: number
  workoutId: number
  stationId: number
  side: string
  id: number
  pixformanceScore: number | null
  precisionScore: number | null
  rangeScore: number | null
  tempoScore: number | null
  repetitionCount: number | null
  repetitionGoal: number | null
  repetitionDuration: number | null
  startedAt?: string
  feedback: { positive: Feedback[], negative: Feedback[] }
  repetitions: RepetitionResult[]

  constructor (attributes?) {
    Object.assign(this, attributes)

    this.repetitions = []
    if (attributes && attributes.repetitions) {
      this.repetitions = attributes.repetitions.map((repetition) => new RepetitionResult(camelcaseKeys(
        repetition, { deep: true })))
    }

    if (attributes && attributes.feedback) {
      if (attributes.feedback.positive) {
        this.feedback.positive = attributes.feedback.positive.map((positive) => new Feedback(camelcaseKeys(
          positive, { deep: true })))
      }
      if (attributes.feedback.negative) {
        this.feedback.negative = attributes.feedback.negative.map((negative) => new Feedback(camelcaseKeys(
          negative, { deep: true })))
      }
    }
  }
}

export class ExerciseResults {
  exerciseResults: ExerciseResult[]

  constructor (attributes?) {
    if (attributes && attributes.exerciseResults) {
      this.exerciseResults = attributes.exerciseResults.map((exercise) => new ExerciseResult(camelcaseKeys(
        exercise, { deep: true })))
    }
  }
}

export class GraphAverageResult {
  startedAt?: string | null
  exerciseId: number
  memberId: number
  stationId: number
  pixformanceScoreAvg: number | null
  precisionScoreAvg: number | null
  rangeScoreAvg: number | null
  tempoScoreAvg: number | null

  constructor (attributes) {
    Object.assign(this, attributes)
  }
}

export class GraphAverageResults {
  averageStats: GraphAverageResult[]

  constructor (attributes?) {
    if (attributes && attributes.averageStats) {
      this.averageStats = attributes.averageStats.map((exercise) => new GraphAverageResult(camelcaseKeys(
        exercise, { deep: true })))
    }
  }
}

class WorkoutResults {

  readonly home: any
  readonly station: StationWorkoutResults[]

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

export default WorkoutResults
